// extracted by css-extract-rspack-plugin
export default {"bottomButtonsArea":"Edit__bottomButtonsArea--u6ofM"};